import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const formatSpecialty = ({
	sp_spec_detail: specDetail,
	sp_certified_by: certifiedBy,
	sp_certified_year: certifiedYear,
}) => {
	let specialty = specDetail;

	if (certifiedBy) {
		specialty += `, ${certifiedBy}`;
	}
	if (certifiedYear) {
		specialty += `, ${certifiedYear}`;
	}

	return specialty;
};

const Specialties = (props) => {
	const specialties = props.data.specialties;

	if (!_.isArray(specialties) || _.isEmpty(specialties)) {
		return null;
	}

	return (
		<ul className="bio-list">
			{_.map(specialties, specialty => (
				<li className="bio-list__item" key={_.uniqueId('list-item-')}>
					{formatSpecialty(specialty)}
				</li>
			))}
		</ul>
	);
};

Specialties.propTypes = {
	data: PropTypes.object.isRequired,
};

export default Specialties;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/specialties.js